import React, { useContext, useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { useTranslation } from "react-i18next";
import { useFetchMarcas } from "../../utilities/hooks/useFetchMarcas.jsx";
import { useCategoryNavigation } from "../../utilities/hooks/Categorias/useCategoryNavigation.jsx";
import { navbarData, politicasAnticorrupcion } from "../../config/config.js";
import { authContext } from "../Context/AuthContext";
import { useGetCategorias } from "../../utilities/hooks/Categorias/useGetCategorias.jsx";
import { useLocation } from "react-router-dom";

const apiProductos = process.env.REACT_APP_API_PRODUCTOS;

export const Barra1 = () => {
  const country = process.env.REACT_APP_COUNTRY;
  const { token } = useContext(authContext);
  const [t] = useTranslation("global");
  const { marcasMapeadas } = useFetchMarcas(apiProductos);
  const { handleMouseEnter, handleMouseLeave, handleClick, renderSubcategories, hoveredCategories } = useCategoryNavigation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [codPath, setCodPath] = useState('');
  const [manPath, setManPath] = useState('');
  const [procPath, setProcPath] = useState('');
  const { categorias, fetchCategorias } = useGetCategorias();
  const location = useLocation();

  // Estados para controlar los dropdowns
  const [showTiendaDropdown, setShowTiendaDropdown] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // 'marcas' o 'categorias'
  const [showCategoriasDropdown, setShowCategoriasDropdown] = useState(false);
  const [showMarcasDropdown, setShowMarcasDropdown] = useState(false);

  // Función para manejar el toggle de cada dropdown
const handleDropdownToggle = (dropdownName, isOpen) => {
  setActiveDropdown(isOpen ? dropdownName : null);
};


  // Función para cerrar todos los dropdowns
  const closeAllDropdowns = () => {
    setShowTiendaDropdown(false);
    setShowCategoriasDropdown(false);
    setShowMarcasDropdown(false);
  };

  // Efecto para cerrar dropdowns al cambiar de ruta
  useEffect(() => {
    closeAllDropdowns();
  }, [location]);

  useEffect(() => {
    setCodPath(politicasAnticorrupcion[country]?.cod || '');
    setManPath(politicasAnticorrupcion[country]?.man || '');
    setProcPath(politicasAnticorrupcion[country]?.proc || '');
  }, []);

  useEffect(() => {
    // Cada vez que cambie la ruta, cierra el dropdown de categorías
    setShowDropdown(false);
  }, [location]);


  const handleMouseEnterDropdown = (dropdownName) => {
    if (dropdownName === "marcas") {
      setShowMarcasDropdown(true);
      setShowCategoriasDropdown(false);
    } else if (dropdownName === "categorias") {
      setShowCategoriasDropdown(true);
      setShowMarcasDropdown(false);
      fetchCategorias(true);
    }
  };
  
  const handleMouseLeaveDropdown = () => {
    setShowMarcasDropdown(false);
    setShowCategoriasDropdown(false);
  };
  

  return (
    <div className="bordeBarraNav">
      <Navbar expand="lg collapseOnSelect" className={`lightNav`}>
        <Container fluid>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="mx-auto" style={{ height: "100%" }}>
              {country !== "JM" && country !== "TT" && country !== "PR" && (
                <NavDropdown
                  title={t("navbar.tienda")}
                  style={{ textTransform: "uppercase" }}
                  id="navbarScrollingDropdown"
                  show={showDropdown}
                  onToggle={(isOpen) => setShowDropdown(isOpen)}
                >
                  {/* Dropdown de marcas */}
                  <NavDropdown
                    title={t("navbar.marcas")}
                    id="navbarScrollingDropdownMarcas"
                    drop="end"
                    show={showMarcasDropdown}
                    onMouseEnter={() => handleMouseEnterDropdown("marcas")}
                    onMouseLeave={handleMouseLeaveDropdown}
                    autoClose="false"
                  >
                    <div className="dropdown-marcas-grid">
                      {[...Array(Math.ceil(marcasMapeadas.length / 21))].map((_, columnIndex) => (
                        <ul key={columnIndex} className="dropdown-marcas-grid-column">
                          {marcasMapeadas
                            .slice(columnIndex * 21, columnIndex * 21 + 21)
                            .map((link) => (
                              <li key={link.Codigo}>
                                <NavDropdown.Item
                                  as={Link}
                                  to={`/marcas/${link.Codigo}`}
                                  className="dropdown-item-marcas"
                                  onClick={() => setShowDropdown(false)}
                                >
                                  {link.Descripcion.toUpperCase()}
                                </NavDropdown.Item>
                              </li>
                            ))}
                        </ul>
                      ))}
                    </div>
                  </NavDropdown>

                  {/* Dropdown de categorías */}
                  <NavDropdown
                     title={t("navbar.categorias")}
                     id="navbarScrollingDropdownMarcas"
                     drop="end"
                     show={showCategoriasDropdown}
                     onMouseEnter={() => handleMouseEnterDropdown("categorias")}
                     onMouseLeave={handleMouseLeaveDropdown}
                     autoClose="false"
                  >
                    <div className="dropdown-categorias-grid">
                      {categorias && Array.isArray(categorias) ? (
                        [...Array(Math.ceil(categorias.length / 10))].map((_, columnIndex) => (
                          <ul key={columnIndex} className="dropdown-categorias-grid-column">
                            {categorias
                              .slice(columnIndex * 10, columnIndex * 10 + 10)
                              .map((categoria) => {
                                const tieneHijos = categoria.Hijos && categoria.Hijos.length > 0;
                                return (
                                  <li
                                    key={categoria.Codigo}
                                    className={tieneHijos ? "categoria-con-sub dropdown" : "categoria-sin-sub"}
                                    onMouseEnter={() => tieneHijos && handleMouseEnter(categoria.Codigo)}
                                    onMouseLeave={() => tieneHijos && handleMouseLeave(categoria.Codigo)}
                                  >
                                    {tieneHijos ? (
                                      <Dropdown show={hoveredCategories[categoria.Codigo]}>
                                        <Dropdown.Toggle
                                          variant="light"
                                          id={`categoria-${categoria.Codigo}`}
                                          onClick={() => handleClick(categoria)}
                                          className="w-100 text-start small-toggle"
                                        >
                                          {categoria.Descripcion.toUpperCase()}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                          {renderSubcategories(categoria.Hijos, () => setShowDropdown(false))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    ) : (
                                      <NavDropdown.Item
                                        as={Link}
                                        to={`/categorias/${categoria.Codigo}`}
                                        className="dropdown-item-categorias"
                                        onClick={() => setShowDropdown(false)}
                                      >
                                        {categoria.Descripcion.toUpperCase()}
                                      </NavDropdown.Item>
                                    )}
                                  </li>
                                );
                              })}
                          </ul>
                        ))
                      ) : (
                        <p>{t("navbar-categorias-no-disponibles")}</p>
                      )}
                    </div>
                  </NavDropdown>
                </NavDropdown>
              )}

              {/*Dropdown de Nosotros */}
              {country !== "JM" && country !== "TT" && country !== "PR" && (
                <NavDropdown
                  title={t("navbar.nosotros")}
                  style={{ textTransform: "uppercase" }}
                  id="navbarScrollingDropdown"
                  onClick={() => setShowDropdown(false)}
                >
                  {navbarData.navbarItems[0].items.map((item, index) => (
                    <NavDropdown.Item key={index}>
                      {item.external ? (
                        <a href={item.to} target="_blank" rel="noopener noreferrer" className="dropdown-item mod" 
                           aria-label={`${t(item.label)} - Abre en nueva ventana`}>
                          {t(item.label)}
                        </a>
                      ) : (
                        <Link to={item.to} className="dropdown-item mod">
                          {t(item.label)}
                        </Link>
                      )}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              )}

              {/* Dropdown de Links útiles */}
              {country !== "JM" && country !== "TT" && country !== "PR" && (
                <NavDropdown
                  title={t("navbar.links-utiles")}
                  style={{ textTransform: "uppercase" }}
                  id="navbarScrollingDropdown"
                  onClick={() => setShowDropdown(false)}
                >
                  {navbarData.navbarItems[1].items.map((item, index) => (
                    (!item.showArg && !item.showUSA) ||
                      (item.showArg && country === "ARG") ||
                      (item.showUSA && country === "USA") ? (
                      item.url ? (
                        <NavDropdown.Item href={item.url} target="_blank" rel="noopener noreferrer" key={index}>
                          <a href={item.url} className="dropdown-item mod" 
                             aria-label={`${t(item.label)} - Abre en nueva ventana`}>
                            {t(item.label)}
                          </a>
                        </NavDropdown.Item>
                      ) : (
                        item.to && (
                          <NavDropdown.Item as={Link} to={item.to} key={index}>
                            {t(item.label)}
                          </NavDropdown.Item>
                        )
                      )
                    ) : null
                  ))}

                  {/* Dropdown de Política Anticorrupción */}
                  <NavDropdown
                    drop="end"
                    title={t("navbar.subitem-politica")}
                    style={{ textTransform: "uppercase" }}
                    id="navbarScrollingDropdownMarcas"
                  >
                    <NavDropdown.Item href={procPath} target="_blank" 
                                    aria-label="Política Anticorrupción - Abre en nueva ventana">
                      {t("navbar.politicas1")}
                    </NavDropdown.Item>
                    <NavDropdown.Item href={codPath} target="_blank" 
                                    aria-label="Código de Ética - Abre en nueva ventana">
                      {t("navbar.politicas2")}
                    </NavDropdown.Item>
                    <NavDropdown.Item href={manPath} target="_blank">
                      {t("navbar.politicas3")}
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                      <Link rel="prefetch" to="/formularioDenuncia" className="dropdown-item mod">
                        {t("navbar.politicas4")}
                      </Link>
                    </NavDropdown.Item>
                  </NavDropdown>
                </NavDropdown>
              )}

              {/* Link / Dropdown de Capacitaciones */}
              {country !== "JM" && country !== "TT" && country !== "PR" && (
                <>
                  {country === "ARG" ? (
                    <NavDropdown
                      title={t("navbar.capacitaciones")}
                      style={{ textTransform: "uppercase" }}
                      id="navbarScrollingDropdown"
                      onClick={() => setShowDropdown(false)}
                    >
                      <NavDropdown.Item as={Link} to="/capacitaciones">
                        VIGENTES
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="https://www.youtube.com/@solutionboxgroup/videos"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Revivi tus webinars - Abre en nueva ventana"
                      >
                        REVIVÍ TUS WEBINARS
                      </NavDropdown.Item>
                    </NavDropdown>
                  ) : (
                    <Nav.Item>
                      <Nav.Link
                        as={Link}
                        to="/capacitaciones"
                        className="navbar-capacitaciones-link"
                      >
                        {t("navbar.capacitaciones")}
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </>
              )}

              {/* Link de Futuros Ingresos - Solo UY */}
              {/* {country === "UY" && (
                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/proximos-ingresos"
                    className="navbar-capacitaciones-link"
                  >
                    {t("navbar.futuros-ingresos")}
                  </Nav.Link>
                </Nav.Item>
              )} */}

              {/* Dropdown de sedes */}
              <NavDropdown
                title={t("navbar.sedes")}
                style={{ textTransform: "uppercase" }}
                id="navbarScrollingDropdown"
              >
                {navbarData.navbarItems[3].items.map((item, index) => (
                  <NavDropdown.Item key={index} href={item.to} target="_blank" className={item.class}>
                    <img src={`${process.env.PUBLIC_URL}${item.image}`} alt={`Bandera ${item.label}`} className="setBanderas" />
                    {item.label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              {/*Dropdown de contacto */}
              <NavDropdown
                title={t("navbar.contacto")}
                style={{ textTransform: "uppercase" }}
                id="navbarScrollingDropdown"
                onClick={() => setShowDropdown(false)}
              >
                <NavDropdown.Item>
                  <Link rel="prefetch" to="contacto" className="dropdown-item mod">
                    {t("navbar.contacto1")}
                  </Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link rel="prefetch" to="trabajaconnosotros" className="dropdown-item mod">
                    {t("navbar.contacto2")}
                  </Link>
                </NavDropdown.Item>
              </NavDropdown>

              {/* Navlink de OFERTAS */}
              {/* <Nav.Item className="ofertas-navlink-container">
                <Nav.Link
                  style={{ textTransform: "uppercase" }}
                  href="/openbox"
                  className="ofertas-navlink"
                >
                  {t("outlet")}
                </Nav.Link>
              </Nav.Item> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
